import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import * as SpinnerReducer from '@store/spinner/reducers';
import {Store} from '@node_modules/@ngrx/store';
import * as AuthReducer from '@store/auth/reducers';
import {User} from '@models/user';
import {PayoutModalObject} from '@interfaces/payoutModalObject';
import { School } from '@app/models/shool';

@Injectable()
export class PaymentService {
  user: User;
  constructor(
    private httpClient: HttpClient,
    private authStore: Store<AuthReducer.AuthState>,
    private spinnerStore: Store<SpinnerReducer.SpinnerState>
  ) {
    this.authStore.subscribe(
      (val) => {
        const auth = val.auth;
        if (auth && auth.user) {
          this.user = auth.user;
        }
      }
    );
  }
  addStripe(body: object) {
    return this.httpClient.post('payment/addStripe', body);
  }

  setChargeStudentSettings(body: {studentId, schoolId, setting}) {
    return this.httpClient.post('payment/set-charge-student-setting', body);
  }

  addOwnerSource(body: object) {
    return this.httpClient.post('payment/add-owner-card', body);
  }

  addStudentSource(body: object) {
    return this.httpClient.post('payment/add-student-card', body);
  }

  addStripeCustomer(userId: number, ownerId: number, source: any){
    return this.httpClient.post('payment/addStripeCustomer', {userId: userId, ownerId: ownerId, source: source});
  }

  savePaymentsSettingsStripe(account_id, school_id?) {
    const body: any = {account_id: account_id};

    if (school_id !== undefined && school_id !== null && school_id !== '') {
      body.school_id = school_id;
    }

    return this.httpClient.post('payment/settingsStripe', body);
  }

  createSchoolStripeOnboardingSession(school_id) {
    return this.httpClient.post('payment/school-stripe/onboarding-session', {school_id: school_id});
  }

  getSchoolStripeReadiness(school_id) {
    return this.httpClient.get('payment/school-stripe/' + school_id + '/readiness');
  }

  disconnectSchoolStripe(school_id) {
    return this.httpClient.post('payment/school-stripe/disconnect', {school_id: school_id});
  }

  getPlatformStripeStatus() {
    return this.httpClient.get('admin/platform-stripe/status');
  }

  disconnectStripe(account_id?) {
    return this.httpClient.post('payment/disconnectStripe', {account_id: account_id});
  }

  savePaymentsSettings(body: object) {
    return this.httpClient.post('payment/settings', body);
  }
  getPaymentsSettings(user: User) {
    return this.httpClient.get('payment/settings/' + user.id);
  }
  getPaymentsMethods() {
    return this.httpClient.get('paymentMethod');
  }
  setPaymentMethod(id_user, id_payment_method) {
    return this.httpClient.post('paymentMethod', {id_user: id_user, id_payment_method: id_payment_method});
  }
  getPaymentsStatisticByMonth(program_id: number) {
    if (this.user.activeSchool) {
      const school_id = this.user.activeSchool;
      return this.httpClient.get(school_id+'/payment/by_month/' + program_id);
    }
    return new Observable();
  }
  getPayoutInformationForUser(school_id: number, teacherId?: number) {
    let url = `${school_id}/payment/payout_teacher/`;

    if(teacherId) {
      url += teacherId;
    }

    return this.httpClient.get(url);
  }
  getStripeInfo(charge_id: number) {
    return this.httpClient.get('payment/stripe-info/' + charge_id);
  }
  getPeyoutsList(user_id = null) {
    if (this.user.activeSchool) {
      const school_id = this.user.activeSchool;
      const usersId = user_id ? '/' + user_id : '';
      return this.httpClient.get(school_id + '/payment/payouts_list' + usersId + '/month');
    }
    return new Observable();
  }
  getPaymentsInformation(
    user_id = null,
    page = 1,
    statuses = [],
    history = false,
    date = '',
    tab = '',
    dateType = '',
  ) {
    if (!user_id && this.user) {
      user_id = this.user.id;
    }
    let school_id;

    if (this.user.role === 'admin') {
        school_id = this.user.activeSchool;
    }

    let type = '';
    if (type) {
        type += '&type=' + type;
    }

    let statusesU = '';

    if (statuses.length > 0) {
        statusesU += '&statuses=' + statuses.join(',');
    }

    let historyQ = '';
    if (history) {
      historyQ += '&history=1';
    }

    let dateQ = '';
    if (date) {
      dateQ += '&date=' + date;
    }

    let dateTypeQ = '';
    if (dateType) {
      dateTypeQ += '&dateType=' + dateType;
    }

    let tabQ = '';
    if (tab) {
      tabQ += '&tab=' + tab;
    }

    if (this.user.role === 'super_admin') {
      return this.httpClient.get(
        'payment/super/' + user_id + '?page=' + page + type + statusesU + historyQ + dateQ + dateTypeQ + tabQ
      );
    } else {
      return this.httpClient.get(
        school_id + '/payment/' + user_id + '?page=' + page + type + statusesU + historyQ + dateQ + dateTypeQ + tabQ
      );
    }
  }

  getGroupedPaymentsInformation(user_id = null, page = 1, statuses = [], dateFrom = '', dateTo = '', tab = '') {
    if (!user_id && this.user) {
      user_id = this.user.id;
    }
    let school_id;

    if (this.user.role === 'admin') {
        school_id = this.user.activeSchool;
    }

    let statusesU = '';

    if (statuses.length > 0) {
        statusesU += '&statuses=' + statuses.join(',');
    }

    let dateFromQ = '';
    if (dateFrom) {
      dateFromQ += '&dateFrom=' + dateFrom;
    }

    let dateToQ = '';
    if (dateTo) {
      dateToQ += '&dateTo=' + dateTo;
    }

    let tabQ = '';
    if (tab) {
      tabQ += '&tab=' + tab;
    }

    if (this.user.role === 'super_admin') {
      return this.httpClient.get('payment/grouped/' + user_id + '?page=' + page + statusesU + dateFromQ + dateToQ + tabQ);
    } else {
      return this.httpClient.get(school_id + '/payment/grouped/' + user_id + '?page=' + page + statusesU + dateFromQ + dateToQ + tabQ);
    }
  }

  getPayouts(user_id = null, dateFrom = '', dateTo = '', action = '', pid = '') {
    if (!user_id && this.user) {
      user_id = this.user.id;
    }
    let school_id;

    if (this.user.role === 'admin') {
        school_id = this.user.activeSchool;
    }

    let dateFromQ = '';
    if (dateFrom) {
      dateFromQ += '&dateFrom=' + dateFrom;
    }

    let dateToQ = '';
    if (dateTo) {
      dateToQ += '&dateTo=' + dateTo;
    }

    let actionQ = '';
    if (action) {
      actionQ += '&action=' + action;
    }

    let pidQ = '';
    if (pid) {
      pidQ += '&pid=' + pid;
    }

    if (this.user.role === 'super_admin') {
      return this.httpClient.get('payment/get-payouts/' + user_id + '?page=1' + dateFromQ + dateToQ + actionQ + pidQ);
    } else {
      return this.httpClient.get(school_id + '/payment/get-payouts/' + user_id + '?page=1' + dateFromQ + dateToQ + actionQ + pidQ);
    }
  }

  getPayoutsData(user_id = null, pid = '', action = '') {
    if (!user_id && this.user) {
      user_id = this.user.id;
    }
    let school_id;

    if (this.user.role === 'admin') {
        school_id = this.user.activeSchool;
    }

    let actionQ = '';
    if (action) {
      actionQ += '&action=' + action;
    }

    let pidQ = '';
    if (pid) {
      pidQ += '&pid=' + pid;
    }

    if (this.user.role === 'super_admin') {
      return this.httpClient.get('payment/get-payout-data/' + user_id + '?page=1' + actionQ + pidQ);
    } else {
      return this.httpClient.get(school_id + '/payment/get-payout-data/' + user_id + '?page=1' + actionQ + pidQ);
    }
  }

  getDataForWidget(user_id = null) {
    if (!user_id && this.user) {
      user_id = this.user.id;
    }

    if (this.user.role === 'admin') {
      return this.httpClient.get(this.user.activeSchool + '/payment/data-for-widget/' + user_id);
    } else if(this.user.role === 'super_admin') {
      return this.httpClient.get('payment/data-for-widget/' + user_id);
    }
  }

  getDataForCountWidget(user_id = null) {
    if (!user_id && this.user) {
      user_id = this.user.id;
    }
    if (this.user.role === 'admin') {
      return this.httpClient.get(this.user.activeSchool + '/school/data-for-widget/' + user_id);
    } else if(this.user.role === 'super_admin') {
      return this.httpClient.get('school/data-for-counter-widget/' + user_id);
    }
  }

  getSchoolCommercialTotals() {
    return this.httpClient.get('admin/school-commercial-totals');
  }

  getFutureGroupedPaymentsInformation(user_id = null, page = 1, dateFrom = '', dateTo = '') {
    if (!user_id && this.user) {
      user_id = this.user.id;
    }
    let school_id;

    if (this.user.role === 'admin') {
        school_id = this.user.activeSchool;
    }

    let dateFromQ = '';
    if (dateFrom) {
      dateFromQ += '&dateFrom=' + dateFrom;
    }

    let dateToQ = '';
    if (dateTo) {
      dateToQ += '&dateTo=' + dateTo;
    }

    if (this.user.role === 'super_admin') {
      //return this.httpClient.get('payment/' + user_id + '?page=' + page + type + statusesU + historyQ + dateQ);
    } else {
      return this.httpClient.get(school_id + '/payment/grouped-future/' + user_id + '?page=' + page + dateFromQ + dateToQ);
    }
  }

  getFuturePaymentsInformation(user_id = null, page = 1, date = '') {
    if (!user_id && this.user) {
      user_id = this.user.id;
    }
    let school_id;

    if (this.user.role === 'admin') {
        school_id = this.user.activeSchool;
    }

    let dateQ = '';
    if (date) {
      dateQ += '&date=' + date;
    }

    if (this.user.role === 'super_admin') {
      //return this.httpClient.get('payment/' + user_id + '?page=' + page + type + statusesU + historyQ + dateQ);
    } else {
      return this.httpClient.get(school_id + '/payment/future/' + user_id + '?page=' + page + dateQ);
    }
  }

  getPaymentsInformationGroup(schoolId: number) {
    return this.httpClient.post('payment/payments_information_group', {school_id: schoolId});
  }
  // getPaymentsNumber(schoolId: number, type: string) {
  //   return this.httpClient.get('payment/payments-number/' + schoolId,
  //     {params: new HttpParams().set('type', type)});
  // }
  // getPaymentsInformationGroup(usersIds) {
  //   return this.httpClient.post('payment/payments_information_group', {user_ids: usersIds});
  // }
  createChargeForProgram(program_id: number, subscription_id: number, user_id?: number, type?: string) {
    const lastPage = window.location.pathname;
    return this.httpClient.post('payment/charge_program',
      {program_id: program_id, subscription_id: subscription_id, user_id: user_id, type: type, lastPage: lastPage});
  }

  /**
   * Start methods for payouts
   */
  createChargeForTeacher(body: {payouts: PayoutModalObject[]}) {
    if (this.user.activeSchool) {
      const school_id = this.user.activeSchool;
      return this.httpClient.post(school_id + '/payment/payout_teacher', body);
    }
    return new Observable();
  }
  getPayOutStastic() {
    if (this.user.activeSchool) {
      const school_id = this.user.activeSchool;
      return this.httpClient.get(school_id + '/payment/payout_teacher');
    }
    return new Observable();
  }
  /**
   * End methods for payouts
   */
  createChargeForOwner(amount: number) {
    if (this.user.activeSchool) {
      const school_id = this.user.activeSchool;
      return this.httpClient.post(school_id+'/payment/charge_owner', {amount: amount, user_id: 1});
    }
    return new Observable();
  }
  putToBalance(amount: number) {
    if (this.user) {
      return this.httpClient.post('payment/putToBalance', {amount: amount, user_id: this.user.id});
    }
    return new Observable();
  }
  payOnholdFee( body: {program_id: number, subscription_id: number, user_id: number, type: string, lastPage?: string}) {
    body.lastPage =  window.location.pathname;
    return this.httpClient.post('payment/charge_program', body);
  }
  getDiscount(body: {subscription_id: number, userSubscription_id: number, price: number}) {
    return this.httpClient.post('payment/price_with_discount', body);
  }
  getTotalPrice(subscriptionId: number) {
    return this.httpClient.get(`subscription/${subscriptionId}/price`);
  }
  getCancelPrice(userId: number, userSubscriptionId: number) {
    return this.httpClient.get(`subscription/user/${userId}/${userSubscriptionId}/cancel/price`);
  }
  deletePayment(charge_id) {
      if (this.user) {
          return this.httpClient.delete('payment/' + charge_id);
      }
      return new Observable();
  }
  refundPayment(charge_id: number, amount: number) {
      if (this.user.activeSchool) {
          return this.httpClient.post(this.user.activeSchool + '/payment/refund', {charge_id: charge_id, amount: amount});
      }
      return new Observable();
  }
  dismissPayment(data) {
    if (this.user.activeSchool) {
      return this.httpClient.post(this.user.activeSchool + '/payment/dismiss', data);
    } else if(this.user.role === 'super_admin') {
      return this.httpClient.post('payment/dismiss-super', data);
    }
    return new Observable();
  }
  refundPaymentExtended(data: {id: number, amount: number, reason: string, reasonText: string}) {
      if (this.user.activeSchool) {
        return this.httpClient.post(this.user.activeSchool + '/payment/refund-extended', data);
      } else if(this.user.role === 'super_admin') {
        return this.httpClient.post('payment/refund-extended', data);
      }
      return new Observable();
  }
  getRefundData(chargeId) {
    if (this.user.activeSchool) {
      return this.httpClient.get(this.user.activeSchool + '/payment/refund-data/' + chargeId);
    } else if(this.user.role === 'super_admin') {
      return this.httpClient.get('payment/refund-data/' + chargeId);
    }
    return new Observable();
  }
  getNextPaymentDate(chargeId) {
    if (this.user.activeSchool) {
      return this.httpClient.get(this.user.activeSchool + '/payment/next-payment-date/' + chargeId);
    }
    return new Observable();
  }
  rechargeExtended(data: any) {
    if (['student_individual', 'student_group'].includes(this.user.role) && this.user.activeSchool) {
      return this.httpClient.post(this.user.activeSchool + '/payment/recharge-student', data);
    } else if (this.user.activeSchool) {
      return this.httpClient.post(this.user.activeSchool + '/payment/recharge-extended', data);
    } else if(this.user.role === 'super_admin') {
      return this.httpClient.post('payment/recharge-super', data);
    }
    return new Observable();
  }
  // My be not used
  recharge(charge_id: number, date: string) {
      if (this.user.activeSchool) {
          return this.httpClient.post(this.user.activeSchool + '/payment/recharge', {charge_id: charge_id, date: date});
      }
      return new Observable();
  }
  reschedule(charge_id: number, date: string, amount: number) {
        if (this.user.activeSchool) {
            const data = {
              charge_id: charge_id,
              date: date,
              amount: amount
            };
            return this.httpClient.post(this.user.activeSchool + '/payment/reschedule', data);
        }
        return new Observable();
  }
  checkUserCanNotBeCharged(schoolUsers: Array<School>, schoolId: number) {
    let result = false;
    schoolUsers.forEach((val) => {
      if (val.id === schoolId) {
        result = val.isUserCanNotBeCharged;
        return null;
      }
    });
    return result;
  }
}
